import { isAnyLogoutMatch } from './account-api.slice';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CsrfTokenState {
    csrfToken: string;
}

const initialState: CsrfTokenState = {
    csrfToken: ''
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        updateCsrfToken: (state, action: PayloadAction<CsrfTokenState>) => {
            if (action.payload.csrfToken) {
                state.csrfToken = action.payload.csrfToken;
            } else {
                console.warn('updateCsrfToken: Tried to update with an empty csrf token, this will not work');
            }
        }
    },
    extraReducers: builder => {
        builder.addMatcher(isAnyLogoutMatch, state => {
            state.csrfToken = '';
        });
    }
});

export const sessionActions = sessionSlice.actions;
